<template>
  <div class="custom-table">
    <template v-for="lib in tableRender" :key="lib.libName">
      <custom-table :libData="lib" @updateTable="updateTable"></custom-table>
    </template>
  </div>
</template>

<script>
import { defineComponent, ref, watch } from "vue";
import customTable from "@/views/rdmanagement/components/database/table.vue";

export default defineComponent({
  props: { libData: Object },
  components: { customTable },
  setup(props, context) {
    const getLibFile = (list, data) => {
      if (!data) return;

      Object.keys(data).forEach((key) => {
        const targetFile = data[key];

        if (targetFile.length > 1) {
          const [firstFile] = targetFile;
          firstFile.rowspan = targetFile.length;

          targetFile.forEach((item, index) => {
            if (index > 0) {
              item.rowspan = null;
            }
          });
        }
        list.push(...targetFile);
      });
    };

    const getLib = (data) => {
      const { input, output } = data;
      const inputFiles = [];
      const outputFiles = [];

      getLibFile(inputFiles, input);
      getLibFile(outputFiles, output);

      return {
        libName: data.theme,
        inputFiles,
        outputFiles,
      };
    };

    const updateTable = () => {
      context.emit("updateTable");
    };

    const tableRender = ref([]);

    watch(
      () => props.libData,
      (val) => {
        tableRender.value.length = 0;
        if (val.length === 0) return;
        val.forEach((item) => {
          tableRender.value.push(getLib(item));
        });
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      updateTable,
      tableRender,
    };
  },
});
</script>

<style lang="less" scoped>
.custom-table {
  width: 100%;
  height: calc(100vh - 220px);
  overflow-y: scroll;
  margin-top: 20px;
}
</style>
